/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './department-speciality.reducer';

export const DepartmentSpecialityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const departmentSpecialityEntity = useAppSelector(state => state.departmentSpeciality.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="departmentSpecialityDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.departmentSpeciality.detail.title">DepartmentSpeciality</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.departmentSpeciality.id">Id</Translate>
            </span>
          </dt>
          <dd>{departmentSpecialityEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.departmentSpeciality.active">Active</Translate>
            </span>
          </dt>
          <dd>{departmentSpecialityEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.departmentSpeciality.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{departmentSpecialityEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.departmentSpeciality.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{departmentSpecialityEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.departmentSpeciality.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{departmentSpecialityEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.departmentSpeciality.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{departmentSpecialityEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.departmentSpeciality.speciality">Speciality</Translate>
          </dt>
          <dd>{departmentSpecialityEntity.speciality ? departmentSpecialityEntity.speciality.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.departmentSpeciality.department">Department</Translate>
          </dt>
          <dd>{departmentSpecialityEntity.department ? departmentSpecialityEntity.department.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/department-speciality" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/department-speciality/${departmentSpecialityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DepartmentSpecialityDetail;
